<div *ngIf="isAdmin" class="btn-container">
  <button pButton pRipple type="button" label="New Note" icon="pi pi-plus" (click)="openNoteDialog('create')"></button>
</div>
<div class="table-container">
  <p-table #dt [value]="progressNotes" styleClass="p-datatable" [loading]="isLoading" [rowHover]="true" [rows]="5"
    [showCurrentPageReport]="true" [rowsPerPageOptions]="[5, 10, 25]" responsiveLayout="scroll" [paginator]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} notes" [filterDelay]="0">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="simDateCreated">
          <div class="flex justify-content-between align-items-center">
            Date/Time
            <p-sortIcon field="simDateCreated"></p-sortIcon>
          </div>
        </th>
        <th pSortableColumn="title">
          <div class="flex justify-content-between align-items-center">
            Title
            <p-sortIcon field="title"></p-sortIcon>
          </div>
        </th>
        <th pSortableColumn="signature">
          <div class="flex justify-content-between align-items-center">
            Signature
            <p-sortIcon field="signature"></p-sortIcon>
          </div>
        </th>
        <!--
        <th *ngIf="isAdmin" pSortableColumn="dateCreated">
          <div class="flex justify-content-between align-items-center">
            Date Created
            <p-sortIcon field="dateCreated"></p-sortIcon>
          </div>
        </th>
      -->
        <th>
          <div class="flex justify-content-between align-items-center">
            <div class="actions-title-container">Actions</div>
          </div>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-note>
      <tr class="p-selectable-row">
        <td>
          {{ note.datetimeString }}
        </td>
        <td>
          {{ note.title }}
        </td>
        <td>
          {{ note.signature }}
        </td>
        <!--
        <td *ngIf="isAdmin">
          {{ note.dateCreatedString }}
        </td>
      -->
        <td class="actions-container">
          <button pButton type="button" class="p-button-primary" icon="pi pi-eye" pTooltip="View note"
            (click)="viewNote(note)"></button>
          <button *ngIf="isAdmin" pButton type="button" class="p-button-warning" icon="pi pi-pencil"
            pTooltip="Edit note" (click)="openNoteDialog('edit', note)"></button>
          <button *ngIf="isAdmin" pButton type="button" class="p-button-danger" icon="pi pi-trash"
            pTooltip="Delete note" (click)="deleteNote(note)"></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8">No notes found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>